const hotelSort = (state = {}, action) => {
    switch (action.type) {
        case 'SAVE_HOTEL_SORT':
            return action.hotelSort
        default:
            return state
    }
}

export default hotelSort
